import { AppConstants } from "../../utils/app-constants";

const batteryManualDesktop: string = AppConstants.BATTERY_CHARGING_DESKTOP;
const batteryManualMobile: string = AppConstants.BATTERY_CHARGING_MOBILE;
const batteryManualTablet: string = AppConstants.BATTERY_CHARGING_TABLET;
const caEmissionsDesktop: string = AppConstants.CA_EMISSIONS_DESKTOP;
const caEmissionsMobile: string = AppConstants.CA_EMISSIONS_MOBILE;
const caEmissionsTablet: string = AppConstants.CA_EMISSIONS_TABLET;
const ownerLiteratureDesktop: string = AppConstants.OWNERS_LITERATURE_DESKTOP;
const ownerLiteratureMobile: string = AppConstants.OWNERS_LITERATURE_MOBILE;
const ownerLiteratureTablet: string = AppConstants.OWNERS_LITERATURE_TABLET;
const ownerManualDesktop: string = AppConstants.OWNERS_MANUAL_DESKTOP;
const ownerManualMobile: string = AppConstants.OWNERS_MANUAL_MOBILE;
const ownerManualTablet: string = AppConstants.OWNERS_MANUAL_TABLET;

export const IMAGE_COLLECTIONS = {
  'OWNER_LITERATURE': {
    desktop: ownerLiteratureDesktop,
    tablet: ownerLiteratureTablet,
    mobile: ownerLiteratureMobile,
  },
  'OWNER_MANUAL': {
    desktop: ownerManualDesktop,
    tablet: ownerManualTablet,
    mobile: ownerManualMobile,
  },
  'CA_EMISSIONS': {
    desktop: caEmissionsDesktop,
    tablet: caEmissionsTablet,
    mobile: caEmissionsMobile,
  },
  'BATTERY_MANUAL': {
    desktop: batteryManualDesktop,
    tablet: batteryManualTablet,
    mobile: batteryManualMobile,
  },
} as const;

export type ImageCollectionKey = keyof typeof IMAGE_COLLECTIONS;